



































































































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { companyServer, doublePrevention, institutionServer, patrolManagementServe, professionServer, regionServe } from '@/api/installServer';
import LinePointTime from './line-point-time.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {
    LinePointTime,
  },
})
export default class PatrolLineEdit extends Vue {
  @Prop() row: any;
  private lineData: any = {};
  private userData: any = {};
  private title = '';
  private scrollbar = true;

  private riskPointTree: any = []; // 风险点列表
  private spaceList: any = [];
  private enterpriseData: any = [];
  private subSpaceByAuthOptions: any = []; // 区域list
  private helpDangerSourceIdList: any = []; // 存储危险源list
  private spaceId: any = '';
  private tableSpaceId: any = '';

  private lineForm: any = {
    loading: false,
    name: '',
    describe: '',
    finishRateAddPoints: '100',
    spacePostId: '',
    pointList: [],
    isEnable: 1,
    taskRiskAssessId: '',
    gatherTagId: '',
    gatherFrequencyLeadPatrol: '',
    sportsTrackFlag: false,
    spaceId: window.localStorage.getItem('spaceId'),
    companyId: '',
    companyName: '',
  };
  private spacePostIdList: any = []; // 岗位列表
  private allPointList: any = []; // 巡检点列表
  // isOpenGatherDataFlag: any = false;
  private frequencyUnitList: any = [
    {
      value: 'hour',
      name: '小时',
    },
    {
      value: 'day',
      name: '天',
    },
    {
      value: 'week',
      name: '周',
    },
    {
      value: 'month',
      name: '月',
    },
  ];
  private lineRules: any = {
    name: [
      { required: true, message: '请输入巡检线路名称', trigger: 'blur' },
      { validator: this.validateName, trigger: 'blur' },
    ],
    // spacePostId: [{ required: true, message: '请选择岗位', trigger: 'change' }],
  };
  private pointRules: any = {
    fequency: [{ type: 'number', required: true, message: '请输入数字', trigger: 'blur' }],
  };

  created() {
    const info: any = localStorage.getItem('userInfo');
    this.userData = JSON.parse(info);
    // this.getIsOpenGatherDataFlag();
    if (this.row.id) {
      this.title = '编辑巡检线路';
      this.findLine(this.row.id);
    } else {
      this.title = '添加巡检线路';
    }
    this.getCompanyList();
    this.getEnterpriseDataList();
    this.getSpaceAreaData();
    this.getSpacePostListAll({ paging: false });
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe
      .getRegionAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.subSpaceByAuthOptions = arrayToTree(res.data);
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 风险点列表
  getRiskPointData(id?: any, index?: any) {
    doublePrevention
      .getRiskAll({
        areaId: id,
      })
      .then((res: any) => {
        if (res.code === '200') {
          res.data.forEach((type: any) => {
            if (type.type === '风险点') {
              // this.riskPointList.push(type);
              this.lineForm.pointList[index].riskPointList.push(type);
            }
            if (type.type === '危险源') {
              this.helpDangerSourceIdList.push(type);
            }
          });
        } else {
          this.$message.warning('获取风险点和危险源的数据失败！');
        }
      });
  }

  // 编辑获取
  // 风险点列表
  getRiskPointDataByEdit(item?: any, index?: any) {
    doublePrevention
      .getRiskAll({
        areaId: item.areaId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          res.data.forEach((type: any) => {
            if (type.type === '风险点') {
              this.lineForm.pointList[index].riskPointList.push(type);
            }
          });
        } else {
          this.$message.warning('获取风险点和危险源的数据失败！');
        }
      });

    doublePrevention
      .getRiskAll({
        areaId: item.areaId,
        pid: item.riskPointId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          res.data.forEach((type: any) => {
            if (type.type === '危险源') {
              this.lineForm.pointList[index].dangerSourceIdList.push(type);
            }
          });
        } else {
          this.$message.warning('获取风险点和危险源的数据失败！');
        }
      });
  }

  // 编辑单独存储危险源获取
  // 风险点列表
  getDangerSourceDataByEdit() {
    doublePrevention.getRiskAll({}).then((res: any) => {
      if (res.code === '200') {
        res.data.forEach((type: any) => {
          if (type.type === '危险源') {
            this.helpDangerSourceIdList.push(type);
          }
        });
      } else {
        this.$message.warning('获取风险点和危险源的数据失败！');
      }
    });
  }

  spaceChange(e: any) {
    this.lineForm.spacePostId = '';
    this.getSpacePostListAll({
      paging: false,
      spaceId: e,
    });
  }
  tableSpaceChange(row: any, index: any) {
    this.lineForm.pointList[index].pointId = '';
    this.getPointListAll({
      paging: false,
      spaceId: row.spaceId,
    });
  }

  tableAreaChange(row: any, index: any) {
    this.lineForm.pointList[index].riskPointId = '';
    this.lineForm.pointList[index].riskPointList = [];
    this.lineForm.pointList[index].dangerSourceId = '';
    this.lineForm.pointList[index].dangerSourceIdList = [];
    this.lineForm.pointList[index].pointId = '';
    this.lineForm.pointList[index].allPointList = [];
    this.helpDangerSourceIdList = [];
    const newA: any = row.areaId.slice(-1).toString();
    this.lineForm.pointList[index].areaId = newA;
    if (newA) {
      this.getRiskPointData(newA, index);
    }
  }

  // 风险点
  getRiskPointId(row: any, index: any) {
    const newA: any = row.riskPointId;
    this.lineForm.pointList[index].dangerSourceId = '';
    this.lineForm.pointList[index].dangerSourceIdList = [];
    this.lineForm.pointList[index].pointId = '';
    this.lineForm.pointList[index].allPointList = [];
    // helpDangerSourceIdList: 存放所有type==='危险源'的数组
    if (newA) {
      this.helpDangerSourceIdList.forEach((data: any) => {
        if (data.pid === newA) {
          this.lineForm.pointList[index].dangerSourceIdList.push(data);
        }
      });
    }
    // this.getDangerSourceId(row, index)
    this.lineForm.pointList[index].pointId = '';
    this.lineForm.pointList[index].allPointList = [];
    this.getPointListAll(
      {
        paging: false,
        spaceId: this.userData.spaceId,
        areaId: row.areaId,
        riskPointId: row.riskPointId,
      },
      index,
    );
  }

  // 风险点编辑
  getRiskPointIdByEdit(row: any, index: any) {
    const newA: any = row.riskPointId;
    // helpDangerSourceIdList: 存放所有type==='危险源'的数组
    if (newA) {
      this.helpDangerSourceIdList.forEach((data: any) => {
        if (data.pid === newA) {
          this.lineForm.pointList[index].dangerSourceIdList.push(data);
        }
      });
    }
  }

  // 危险源change
  getDangerSourceId(row: any, index: any) {
    this.lineForm.pointList[index].pointId = '';
    this.lineForm.pointList[index].allPointList = [];
    const newA: any = row.dangerSourceId;
    if (newA) {
      this.getPointListAll(
        {
          paging: false,
          spaceId: this.userData.spaceId,
          areaId: row.areaId,
          riskPointId: row.riskPointId,
          dangerSourceId: row.dangerSourceId ? row.dangerSourceId : null,
        },
        index,
      );
    }
  }
  /**
   * 【接口】获取企业列表
   */
  private getEnterpriseDataList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'COMPANY',
      })
      .then((res: any) => {
        this.enterpriseData = res.data;
      });
  }
  companyChange(e: any) {
    this.lineForm.companyName = '';
    if (e) {
      this.lineForm.companyName = this.enterpriseData.find((item: any) => item.id === e).companyName;
    }
  }

  /**
   *【接口】获取单位
   * @Params
   * @return
   **/
  async getCompanyList() {
    try {
      const res: any = await institutionServer.getCompanyList({});
      if (res.code === '200') {
        this.spaceList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  changePointEdit(data: any, index: any) {
    data.edit = true;
    this.helpDangerSourceIdList = [];
    this.getDangerSourceDataByEdit();
    this.lineForm.pointList[index].dangerSourceIdList = [];
    this.lineForm.pointList[index].allPointList = [];
    this.lineForm.pointList[index].riskPointList = [];

    this.getRiskPointDataByEdit(data, index);
    this.getRiskPointIdByEdit(data, index);
    this.getPointListAllByEdit(
      {
        paging: false,
        spaceId: this.userData.spaceId,
        areaId: data.areaId,
        riskPointId: data.riskPointId,
        dangerSourceId: data.dangerSourceId,
      },
      index,
    );
  }

  handleAssignmentDetailBtn() {
    if (this.lineForm.taskRiskAssessId == '' || !this.lineForm.taskRiskAssessId) {
      this.$message.warning('请先绑定对应的风险评估');
    } else {
      this.$router.push({ name: 'AssignmentEvaluationEdit', query: { type: 'edit', id: this.lineForm.taskRiskAssessId } });
    }
  }

  /**
   * 【按钮】添加巡检点
   * @Params
   * @return
   **/
  addPoint() {
    let sort = 0;
    this.lineForm.pointList.forEach((item: any) => {
      if (item.sort > sort) sort = item.sort;
    });
    this.lineForm.pointList.push({
      riskPointId: '',
      riskPointList: [],
      dangerSourceId: '',
      dangerSourceIdList: [],
      pointId: '',
      allPointList: [],
      fequency: '',
      frequencyUnit: 'hour',
      sort: sort + 100,
      timeInfo: [],
      edit: true,
      spaceId: this.userData.spaceId,
    });
  }

  /**
   *【按钮】复制巡检点时间生成一条新的记录
   * @Params
   * @return
   **/
  copyItemBtn(data: any) {
    const temp: any = [];
    data.row.timeInfo.forEach((item: any) => {
      temp.push({
        startTime: item.startTime,
        endTime: item.endTime,
      });
    });
    this.lineForm.loading = true;
    this.lineForm.pointList.splice(data.$index + 1, 0, {
      riskPointId: '',
      riskPointList: [],
      dangerSourceId: '',
      dangerSourceIdList: [],
      pointId: '',
      allPointList: [],
      fequency: '',
      frequencyUnit: 'hour',
      sort: (data.$index + 1) * 100,
      timeInfo: temp,
      edit: true,
      spaceId: this.userData.spaceId,
    });
    setTimeout(() => {
      this.lineForm.loading = false;
    }, 1000);
    this.lineForm.pointList.forEach((item: any, index: any) => {
      item.sort = (index + 1) * 100;
    });
  }

  addpointTime(data: any, index: any) {
    const pointTime: any = this.$refs['linePointTime'];
    pointTime.showDialog(data, index);
  }

  /**
   * 【按钮】返回按钮
   * @Params
   * @return
   **/
  goBack() {
    this.$emit('on-response');
  }

  /**
   * 【按钮】提交按钮点击
   */
  handleSubmitBtnClick() {
    const formComponent: any = this.$refs['lineForm'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      switch (this.title) {
        case '添加巡检线路':
          this.addLineData();
          break;
        case '编辑巡检线路':
          this.editLineData();
          break;
      }
    });
  }

  /**
   *【按钮】删除按钮点击
   * @Params
   * @return
   **/
  handleDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该巡检点, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.handleTableDeleteBtnClick(data);
      })
      .catch(() => {});
  }

  /**
   * 删除单个巡检时间
   * @Params
   * @return
   **/
  delTime(data: any, index: any) {
    data.timeInfo.splice(index, 1);
  }

  /**
   * 【表格】表格删除按钮
   * @Params
   * @return
   **/
  async handleTableDeleteBtnClick(data: any) {
    const _index: number = this.getIndex(data);
    this.lineForm.pointList.splice(_index, 1);
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    const formComponent: any = this.$refs['lineForm'];
    formComponent.resetFields();
  }

  /**
   * 【表单】表单赋值
   */
  private assignDataToForm(data: any) {
    this.lineForm = {
      ...this.lineForm,
      ...{
        name: data.name,
        describe: data.describe,
        spacePostId: data.spacePostId,
        finishRateAddPoints: data.finishRateAddPoints,
        pointList: data.pointList,
        taskRiskAssessId: data.taskRiskAssessId,
        sportsTrackFlag: data.sportsTrackFlag,
        gatherFrequencyLeadPatrol: data.gatherFrequencyLeadPatrol,
        gatherTagId: data.gatherTagId,
        spaceId: data.spaceId,
        companyId: data.companyId,
        companyName: data.companyName,
      },
    };

    this.lineForm.pointList.forEach((item: any, index: any) => {
      this.$set(item, 'edit', false);
      this.$set(item, 'riskPointList', []);
      this.$set(item, 'dangerSourceIdList', []);
      this.$set(item, 'allPointList', []);
    });
  }

  /**
   *【巡检时间编辑窗口】巡检时间编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handlePointTimeResponse() {}

  /**
   * 【接口】获取详情
   */
  async findLine(id: any) {
    this.lineForm.loading = true;
    try {
      const res: any = await patrolManagementServe.getPatrolLineSingleData(id);
      if (res.code === '200') {
        this.lineData = res.data;
        setTimeout(() => {
          this.assignDataToForm(res.data);
          this.getSpacePostListAll({
            paging: false,
            spaceId: this.lineForm.spaceId ? this.lineForm.spaceId : null,
          });
        }, 20);
        this.lineForm.loading = false;
        return res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】添加巡检线路
   */
  async addLineData() {
    try {
      const pointList: Array<any> = [];
      this.lineForm.pointList.forEach((item: any) => {
        pointList.push(item);
      });

      const res: any = await patrolManagementServe.addPatrolLine({
        name: this.lineForm.name,
        describe: this.lineForm.describe,
        spacePostId: this.lineForm.spacePostId,
        finishRateAddPoints: this.lineForm.finishRateAddPoints,
        taskRiskAssessId: this.lineForm.taskRiskAssessId,
        sportsTrackFlag: this.lineForm.sportsTrackFlag,
        gatherFrequencyLeadPatrol: this.lineForm.gatherFrequencyLeadPatrol,
        gatherTagId: this.lineForm.gatherTagId,
        isEnable: 1,
        pointList: pointList,
        spaceId: this.lineForm.spaceId,
        companyId: this.lineForm.companyId,
        companyName: this.lineForm.companyName,
      });
      if (res.code == 201) {
        this.$message.success('您成功添加了记录。');
        this.goBack();
      } else {
        this.$message.warning('添加失败。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】编辑巡检线路
   */
  async editLineData() {
    try {
      const pointList: any = [];
      this.lineForm.pointList.forEach((item: any) => {
        pointList.push(item);
      });
      const res: any = await patrolManagementServe.editPatrolLineData(this.row.id, {
        name: this.lineForm.name,
        describe: this.lineForm.describe,
        spacePostId: this.lineForm.spacePostId,
        finishRateAddPoints: this.lineForm.finishRateAddPoints,
        taskRiskAssessId: this.lineForm.taskRiskAssessId,
        sportsTrackFlag: this.lineForm.sportsTrackFlag,
        gatherFrequencyLeadPatrol: this.lineForm.gatherFrequencyLeadPatrol,
        gatherTagId: this.lineForm.gatherTagId,
        isEnable: 1,
        pointList: pointList,
        spaceId: this.lineForm.spaceId,
        companyId: this.lineForm.companyId,
        companyName: this.lineForm.companyName,
      });
      if (res.code == 201) {
        this.$message.success('您成功编辑记录。');
        this.goBack();
      } else {
        this.$message.warning('编辑失败。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】获取全部空间岗位列表
   * @Params
   * @return
   **/
  async getSpacePostListAll(opts: object) {
    try {
      const res: any = await professionServer.getPageDataAll(opts);
      if (res.code === '200') {
        this.spacePostIdList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】获取全部巡检点列表
   * @Params
   * @return
   **/
  async getPointListAll(opts: object, index?: any) {
    try {
      const res: any = await patrolManagementServe.getPatrolPointAllData(opts);
      if (res.code === '200') {
        this.lineForm.pointList[index].allPointList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】编辑获取全部巡检点列表
   * @Params
   * @return
   **/
  async getPointListAllByEdit(opts: object, index?: any) {
    try {
      const res: any = await patrolManagementServe.getPatrolPointAllData(opts);
      if (res.code === '200') {
        this.lineForm.pointList[index].allPointList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  // 公司（单位）数据
  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  areaIdToName(id: any) {
    const a: any = this.subSpaceByAuthOptions.find((s: any) => {
      return s.id === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  /**
   * 【验证】验证巡检线路名称
   * @param rule {any} 验证规则
   * @param value {any} 验证值
   * @param callback {any} 验证结果回调方法
   */
  async validateName(rule: any, value: any, callback: any) {
    // 如果修改的内容没发生变化则不进行服务器校验
    if (this.title === '编辑巡检线路') {
      if (this.lineData.name === value) {
        callback();
        return;
      }
    }
    const res: any = await patrolManagementServe.patrolLineCheckName({ name: value });
    switch (res.code) {
      case 20001:
        callback();
        break;
      case 20002:
        callback(new Error('巡检线路名称已存在'));
        break;
    }
  }

  /**
   * 【方法】获取下标
   */
  getIndex(data: any) {
    return this.lineForm.pointList.findIndex((item: any) => {
      return item == data;
    });
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }
}
